module.exports = __webpack_public_path__ + "assets/img/logo.44c0ff30.png";